import PropTypes from "prop-types";
import { Modal, ModalBody } from "reactstrap";
import CLoseImg from "../../../assets/images/closeIconModal.svg";
import warning from "../../../assets/images/warningRed.png";
import "../SelectedComponent.scss";
import { useState } from "react";

const WithDrawModal = ({ show, onCloseClick, onWithdraw, product }: any) => {
  const [selectedReason, setSelectedReason] = useState<string | null>(null);

  const handleCheckboxChange = (reason: string) => {
    setSelectedReason(reason);
  };

  return (
    <Modal isOpen={show} centered className="WidthDrawMOdal">
      <ModalBody className="modal_Body">
        <img
          data-testing-id="closeIcon"
          onClick={() => onCloseClick(false)}
          className="closeIconModal"
          src={CLoseImg}
          alt=""
        />
        <div className="WarningHeadText">
          <div className="warningImg">
            <div className="d-flex gap-2 align-item-center">
              <img src={warning} alt="" />
              <h1>Are you sure to withdraw?</h1>
            </div>
            <p>
              Are you sure you want to withdraw{" "}
              <strong>{product?.name}</strong>? Don't miss out on our upcoming
              flash sale! Make your decision before the early registration
              period closes!
            </p>
          </div>
          <div>
            <a>Please tell us why you want to withdraw the selected product:</a>
          </div>
          <div className="inputCheckedMain">
            {[
              "Price error",
              "Product information error",
              "Out of stock",
              "Other Options",
            ].map((reason) => (
              <div className="input" key={reason}>
                <input
                  type="checkbox"
                  checked={selectedReason === reason}
                  onChange={() => handleCheckboxChange(reason)}
                  className="sellerCheckbox m-0 form-check-input"
                  data-testing-id={`${reason
                    .replace(/\s+/g, "")
                    .toLowerCase()}InputChecked_WithDrawModal`}
                />
                <h6>{reason}</h6>
              </div>
            ))}
          </div>
          <div className="btns">
            <button
              className="differentButton" data-testing-id="cancelButton_WithDrawModal"
              onClick={() => onCloseClick(false)}
            >
              Cancel
            </button>
            <button data-testing-id="withdrawButton_WithDrawModal"
              onClick={() => {
                if (selectedReason) {
                  onWithdraw(selectedReason);
                } else {
                  alert("Please select a reason!");
                }
              }}
            >
              Withdraw
            </button>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

WithDrawModal.propTypes = {
  onCloseClick: PropTypes.func,
  show: PropTypes.bool,
  onWithdraw: PropTypes.func,
  product: PropTypes.object,
};

export default WithDrawModal;
